import {createApi,fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import { baseUrl } from '../components/constant/baseUrl'

export const myApi=createApi({
       reducerPath:"myApi",
       baseQuery:fetchBaseQuery({
        baseUrl:baseUrl,
        prepareHeaders: async (headers) => {
         const token = await localStorage.getItem('token')
         if (!!token) {
             headers.set('Authorization', `Bearer ${token}`)
         }
         return headers
     }
             }),
    tagTypes: ["user","userapi","tradecard","tradehistory"],
       endpoints:(builder)=>({
       }),

})